import { api, apiCall, apiActionDispatcher } from './api';
import { addControlTelemetryActionTypes } from './types';
import { REQUEST_HEADER } from './../helpers/httpRequestHeader';

const addControlTelemetryDispatcher =
  apiActionDispatcher({
    actionTypes: addControlTelemetryActionTypes,
    responseHandler: null
  });
export const addControlTelemetry = (controlName, requestHeader = REQUEST_HEADER) =>
  apiCall(
    addControlTelemetryDispatcher,
    api.telemetry.addControlTelemetry,
    null,
    null,
    null,
    [controlName],
    null,
    null,
    requestHeader
  );



// WEBPACK FOOTER //
// src/actions/telemetry.js